import { render, staticRenderFns } from "./BrushChart.vue?vue&type=template&id=36f682c6&scoped=true&"
import script from "./BrushChart.vue?vue&type=script&lang=js&"
export * from "./BrushChart.vue?vue&type=script&lang=js&"
import style0 from "./BrushChart.vue?vue&type=style&index=0&id=36f682c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f682c6",
  null
  
)

export default component.exports